<template>
    <div class="stage">
        <div class="questions-wrapper">
            <div class="questions-block">
                <div class="question-block">
                    <div class="question">
                        Якої статі Ваш пацієнт?
                    </div>
                    <div class="answers">
                        <div class="answer" :class="isMale === 'Чоловік' ? 'active' : ''" @click="isMale = 'Чоловік'">
                            <input type="radio" id="male" name="gender" v-model="isMale" value="Чоловік" required>
                            <label for="male">Чоловік</label>
                        </div>
                        <div class="answer" :class="isMale === 'Жінка' ? 'active' : ''" @click="isMale = 'Жінка'">
                            <input type="radio" id="female" name="gender" v-model="isMale" value="Жінка" required>
                        <label for="female">Жінка</label>
                        </div>
                    </div>
                </div>

                <div class="question-block">
                    <div class="question">
                        Скільки йому / їй років?
                    </div>
                    <div class="answers">
                        <div class="answer" :class="age === '18-30' ? 'active' : ''" @click="age = '18-30'">
                            <input type="radio" id="18" name="age" v-model="age" value="18-30" required>
                            <label for="18">18-30</label>
                        </div>
                        <div class="answer" :class="age === '31-40' ? 'active' : ''" @click="age = '31-40'">
                            <input type="radio" id="31" name="age" v-model="age" value="31-40" required>
                            <label for="31">31-40</label>
                        </div>
                        <div class="answer" :class="age === '41-50' ? 'active' : ''" @click="age = '41-50'">
                            <input type="radio" id="41" name="age" v-model="age" value="41-50" required>
                            <label for="41">41-50</label>
                        </div>
                        <div class="answer" :class="age === '51-60' ? 'active' : ''" @click="age = '51-60'">
                            <input type="radio" id="51" name="age" v-model="age" value="51-60" required>
                            <label for="51">51-60</label><br>
                        </div>
                        <div class="answer" :class="age === '60+' ? 'active' : ''" @click="age = '60+'">
                            <input type="radio" id="60" name="age" v-model="age" value="60+" required>
                            <label for="60">60+</label><br>
                        </div>
                    </div>
                </div>

                <error-block />
            </div>
        </div>
    </div>
</template>

<script>
import ErrorBlock from '../../../components/Doctor/ErrorBlock';
import { mapMutations } from 'vuex';

export default {
    components : {
        'error-block' : ErrorBlock
    },
    data : () => ({
        isMale : '',
        age : ''
    }),
    methods : {
        ...mapMutations([
            'setCurrentRoute',
            'setCurrentRouteIndex'
        ])
    },
    created(){
        this.isMale = this.$store.state.patient.mainInfo.gender;
        this.age = this.$store.state.patient.mainInfo.ageRange;

        this.setCurrentRoute('/create-patient/stage/1');
        this.setCurrentRouteIndex(0);
    },
    watch : {
        isMale : function(value){
            this.$store.commit('setGender', value);
        },
        age : function(value){
            this.$store.commit('setAge', value);
        }
    }
}
</script>

<style lang="scss">
.stage{
    width: 100%;
    height: 100%;

    display: flex;
    align-items: center;
    justify-content: center;

    .questions-wrapper{
        background: #F1F4F5;
        border-radius: 20px;

        width: 405px;
        height: 412px;

        .questions-block{
            padding: 20px 40px;

            .question-block{
                .question{
                    font-style: normal;
                    font-weight: bold;
                    font-size: 24px;
                    line-height: 28px;

                    color: #575A5D;

                    padding-bottom: 22px;
                    text-align: left;
                }

                .answers{
                    display: flex;
                    flex-direction: row;
                    flex-wrap: wrap;

                    padding-bottom: 18px;

                    .answer{
                        width: 45%;

                        background: #FFFFFF;
                        box-shadow: 4px 4px 20px rgba(37, 93, 111, 0.1);
                        border-radius: 50px;

                        padding: 11px 0;
                        margin-bottom: 15px;

                        display: flex;
                        flex-direction: row;
                        align-items: center;

                        input[type="radio"] {
                            display: none;
                        }

                        input[type="radio"] + *::before {
                            content: "";
                            display: inline-block;
                            vertical-align: bottom;
                            width: 20px;
                            height: 20px;
                            margin-left: 12px;
                            margin-right: 8px;
                            border-radius: 50%;
                            border: 1px solid rgba(0, 0, 0, 0.1);
                        }

                        input[type="radio"]:checked + *::before {
                            background: #FFFFFF;
                            width: 8px;
                            height: 8px;
                            border: 7px solid rgba(0, 96, 126, 0.75);
                        }

                        input{
                            margin: 0;
                            margin-left: 12px;

                            width: 20px;
                            height: 20px;

                            border: 1px solid rgba(0, 0, 0, 0.1);
                            box-sizing: border-box;
                        }

                        label{
                            font-style: normal;
                            font-weight: 750;
                            font-size: 14px;

                            color: #757575;

                            padding-left: 10px;

                            display: flex;
                            align-items: center;
                        }
                    }

                    .active{
                        border: 1px solid rgba(0, 96, 126, 0.75);

                        label{
                            color: #00607E;
                        }
                    }

                    .answer:nth-child(2n){
                        margin-left: 5%;
                    }
                }
            }

            .question-block:nth-child(2n){
                .answers{
                    padding-bottom: 0;
                }
            }            
        }        
    }
}

@media (min-width: 1024px) and (min-aspect-ratio: 16/9) {
    .stage{
        .questions-wrapper{
            width: 43vw;
            height: auto;

            .questions-block{
                padding: 2.500vw 3.125vw;

                .question-block{
                    .question{
                        font-size: 1.667vw;
                        line-height: 1.823vw;

                        padding-bottom: 1.771vw;
                    }

                    .answers{
                        padding-bottom: 2.24vw;

                        .answer{
                            width: 30%;

                            padding: 1.042vw 0;
                            margin-bottom: 1.354vw;

                            margin-right: 1.042vw;

                            input[type="radio"] + *::before {
                                width: 1.667vw;
                                height: 1.667vw;
                                margin-left: 1.042vw;
                                margin-right: 0.833vw;
                            }

                            input[type="radio"]:checked + *::before {
                                width: 1vw;
                                height: 1vw;
                                border: 7px solid rgba(0, 96, 126, 0.75);
                            }

                            input{
                                margin: 0;
                                margin-left: 12px;

                                width: 1.667vw;
                                height: 1.667vw;
                            }

                            label{
                                font-size: 1.042vw;

                                padding-left: 0.833vw;
                            }
                        }

                        .answer:nth-child(2n){
                            margin-left: 0;
                        }

                        .answer:nth-child(3n){
                            margin-right: 0;
                        }
                    }
                }        
            }     
        }
    }
}

@media (min-width: 1024px) and (min-aspect-ratio: 21/9) {
    .stage{
        .questions-wrapper{
            width: 35vw;
            height: auto;

            .questions-block{
                padding: 2vw 2.8vw;

                .question-block{
                    .question{
                        font-size: 1.3vw;
                        line-height: 1.5vw;

                        padding-bottom: 1.5vw;
                    }

                    .answers{
                        padding-bottom: 1.5vw;

                        .answer{
                            width: 30%;

                            padding: 0.8vw 0;
                            margin-bottom: 1vw;

                            margin-right: 0.9vw;

                            input[type="radio"] + *::before {
                                width: 1.1vw;
                                height: 1.1vw;
                                margin-left: 0.4vw;
                                margin-right: 0.7vw;
                            }

                            input[type="radio"]:checked + *::before {
                                width: 0.7vw;
                                height: 0.7vw;
                            }

                            input{
                                width: 1.3vw;
                                height: 1.3vw;
                            }

                            label{
                                font-size: 0.9vw;

                                padding-left: 0.833vw;
                            }
                        }
                    }
                }        
            }     
        }
    }
}

@media (max-width: 599px){
    .stage{
        align-items: flex-start;

        .questions-wrapper{
            width: 100%;
            height: auto;

            .questions-block{
                padding: 5vw 4.8vw 6vw 5vw;

                .question-block{
                    .question{
                        font-size: 5vw;
                        line-height: 6vw;

                        padding-bottom: 3vw;
                    }

                    .answers{
                        padding-bottom: 5vw;

                        .answer{
                            width: 55%;

                            padding: 2vw 0;
                            margin-bottom: 2.222vw;

                            input[type="radio"] + *::before {
                                width: 5.556vw;
                                height: 5.556vw;
                                margin-left: 3.333vw;
                                margin-right: 2.222vw;
                            }

                            input[type="radio"]:checked + *::before {
                                width: 2.222vw;
                                height: 2.222vw;
                                border: 1.944vw solid rgba(0, 96, 126, 0.75);
                            }

                            input{
                                margin-left: 3.333vw;

                                width: 5.556vw;
                                height: 5.556vw;
                            }

                            label{
                                font-size: 3.889vw;
                                padding-left: 3.611vw;
                            }
                        }

                        .answer:nth-child(2n){
                            margin-left: 0;
                        }

                        .answer:last-child{
                            margin-bottom: 0;
                        }
                    }
                }
            }
        }
    }
}
</style>